module.exports = "https://assets.pclncdn.com/web/next-landing/b8f04f44e5/_next/static/images/rcBumper-9f864eebd1867e65bb8f5bced2341195.png";